/** 状态管理器中间件 */

export default function persistentCachePlugin(whiteList = []) {
  return store => {
    /** 还原数据 */
    whiteList.forEach(item => {
      /**
       * storageType 存储类型 2 sessionStorage 其他 localStorage
       * updateName store中更新数据的方法名
       * cacheKey 存入本地的字段名
       */
      let { storageType = 2, updateName = '', cacheKey = '', isInit } = item
      let storage = storageType === 2 ? window.sessionStorage : window.localStorage
      if (storage[cacheKey] && updateName !== '' && isInit) {
        if (store._mutations && store._mutations[updateName]) {
          JSON.parse(storage[cacheKey]).forEach(_item => {
            store.commit(updateName, _item)
          })
        }
      }
    })
    /** 存储数据 */
    store.subscribe((mutation, state) => {
      whiteList.forEach(item => {
        /**
         * storageType 存储类型 2 sessionStorage 其他 localStorage
         * stateName state中数据存储的字段
         * cacheKey 存入本地的字段名
         */
        let { storageType = 2, stateName = '', cacheKey = '' } = item
        if (stateName !== '' && cacheKey !== '') {
          let stateDatas = getdeepObjData(state, stateName)
          if (stateDatas && stateDatas.length > 0) {
            let storage = storageType === 2 ? window.sessionStorage : window.localStorage
            try {
              storage.setItem(cacheKey, JSON.stringify(stateDatas))
            } catch (err) {
              console.log(err)
            }
          }
        }
      })
    })
  }
}

/** 深层对象数据 */
function getdeepObjData(model = {}, str) {
  let obj = false
  str.split('/').forEach((item, index) => {
    obj = index === 0 ? model[item] : (obj && obj[item]) || false
  })
  return obj
}
